import * as yup from 'yup';
import { CitySearchFormModel } from './model';

export const citySearchFormSchema: yup.SchemaOf<CitySearchFormModel> = yup.object({
  citySearchQuery: yup
    .string()
    .required()
    .test('isSearchText', 'Поле поиска пусто', (val) => Boolean(val)),
});
